// packages/services/src/productService.ts
import { PaginatedResponse, Product } from '@cabukaka/types'
import { dataService } from './core/dataService';
import axios from 'axios';
import { getConfig } from '@cabukaka/config/index';
import { mapMongoDocs } from '@cabukaka/utils/index';

export const productService = {

    get baseService() {
        return dataService<Product>("products");
    },

    // ============================================
    // Méthodes utilisant axios directement
    // ============================================

    getStationProducts: async (token?: string): Promise<PaginatedResponse<Product>> => {
        return productService.getProductsBySectorSlug(token, "station-service");
    },

    getProductsBySectorSlug: async (token?: string, slug?: string): Promise<PaginatedResponse<Product>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Product>>(`${apiUrl}/products/sector/slug/${slug}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },
    getProductsByShopId: async (shopId: string, token?: string): Promise<PaginatedResponse<Product>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Product>>(`${apiUrl}/products/shop/${shopId}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getProductByCategorySlug: async (slug: string, token?: string): Promise<PaginatedResponse<Product>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Product>>(`${apiUrl}/products/category/slug/${slug}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                ...res.data,

                data: mapMongoDocs(res.data.data),
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getProductBySlug: async (slug: string, token?: string): Promise<Product | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<Product>(`${apiUrl}/products/slug/${slug}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                ...res.data,
                id: (res.data as any)._id 
            };
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    // ============================================
    // Méthodes utilisant baseService
    // ============================================

    getProducts: async (page: number = 1, limit: number = 20): Promise<PaginatedResponse<Product>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Product>>(`${apiUrl}/products/all`, {
              
                params: {  page, limit }
            });
            return {
                data: mapMongoDocs(res.data.data),
                total: res.data.total,
                pages: res.data.pages
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    // ============================================
    // Méthodes spécifiques avec leur propre endpoint
    // ============================================

    searchProducts: async (query: string, page: number = 1, limit: number = 20, token?: string): Promise<PaginatedResponse<Product>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Product>>(`${apiUrl}/products/search`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                params: { q: query, page, limit }
            });
            return {
                data: mapMongoDocs(res.data.data),
                total: res.data.total,
                pages: res.data.pages
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getProductsByIds: async (ids: string[], token?: string): Promise<PaginatedResponse<Product>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.post<PaginatedResponse<Product>>(`${apiUrl}/products/by-ids`, { ids }, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return {
                data: mapMongoDocs(res.data.data),
                total: res.data.total,
                pages: res.data.pages
            };;
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },
};